export default __webpack_public_path__ + "static/media/white-logo.ef33d1ef.png";